export const dailyQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "A vacuum cleaner has been placed near the sofa.",
      B: "A man is sweeping the floor.",
      C: "A chair is being moved across the room.",
      D: "The windows have been covered with curtains.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 바닥을 쓸고 있음\n" +
      "오답 설명: (A) 진공청소기가 없음, (C) 의자가 움직이지 않음, (D) 커튼이 보이지 않음",
  },

  {
    questionNumber: 2,
    choices: {
      A: "A book has been placed on the table.",
      B: "A person is wiping the windows.",
      C: "A lamp is being turned off.",
      D: "The floor is being mopped.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 바닥이 닦여지고 있음\n" +
      "오답 설명: (A) 책이 없음, (B) 창문을 닦지 않음, (C) 램프를 조작하지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "The window blinds have been pulled down.",
      B: "A man is putting on gloves.",
      C: "The window is open.",
      D: "A man is wiping a window.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 남자가 창문을 닦고 있음\n" +
      "오답 설명: (A) 블라인드가 보이지 않음, (B) 이미 장갑을 끼고 있음, (C) 창문이 닫혀있음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "The window is open.",
      B: "A towel has been placed on the table.",
      C: "A curtain is being installed.",
      D: "A woman is wearing an apron.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 여자가 앞치마를 입고 있음\n" +
      "오답 설명: (A) 창문이 닫혀있음, (B) 테이블에 수건이 없음, (C) 커튼을 설치하지 않음",
  },

  {
    questionNumber: 5,
    choices: {
      A: "A woman is dusting a picture frame.",
      B: "A clock is being placed on a shelf.",
      C: "Picture frames are being mounted.",
      D: "A plant is being watered.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 액자를 닦고 있음\n" +
      "오답 설명: (B) 시계가 이미 설치되어 있음, (C) 액자가 이미 걸려있음, (D) 식물에 물을 주지 않음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "The TV is turned on.",
      B: "A man is vacuuming a sofa.",
      C: "A cushion is on the floor.",
      D: "A rug is being laid on the floor.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 소파를 진공청소기로 청소하고 있음\n" +
      "오답 설명: (A) TV가 꺼져있음, (C) 쿠션이 소파에 있음, (D) 러그가 이미 깔려있음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "A mirror has been placed on the floor.",
      B: "Two people are making a bed.",
      C: "A woman is putting on a pillowcase.",
      D: "A drawer has been left open.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 두 사람이 침대를 정리하고 있음\n" +
      "오답 설명: (A) 거울이 바닥에 있지 않음, (C) 배개에 커버를 씌우지 않음, (D) 서랍이 닫혀있음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "A man is loading clothes into a washing machine.",
      B: "A man is pressing buttons on the washing machine.",
      C: "Some towels are being folded on the counter.",
      D: "The blinds are being adjusted.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 세탁기에 옷을 넣고 있음\n" +
      "오답 설명: (B) 세탁기 버튼을 누르지 않음, (C) 수건을 접지 않음, (D) 블라인드를 조정하지 않음",
    imageUrl: "/images/part1/people/daily/daily11.png",
    audioUrl: "/audios/part1/people/daily/daily11.mp3",
  },
  {
    questionNumber: 9,
    choices: {
      A: "A woman is taking laundry out of a washing machine.",
      B: "An iron has been placed on a table.",
      C: "A woman is holding a detergent bottle.",
      D: "Some towels have been folded on a table.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 세탁기에서 빨래를 꺼내고 있음\n" +
      "오답 설명: (B) 다리미가 테이블이 아닌 선반에 있음, (C) 세제를 들고 있지 않음, (D) 수건이 테이블이 아닌 선반에 있음",
    imageUrl: "/images/part1/people/daily/daily12.png",
    audioUrl: "/audios/part1/people/daily/daily12.mp3",
  },
  {
    questionNumber: 10,
    choices: {
      A: "The woman is folding some clothes.",
      B: "A woman is cooking in the kitchen.",
      C: "The woman is hanging up laundry.",
      D: "A woman is ironing a shirt.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 빨래를 널고 있음\n" +
      "오답 설명: (A) 옷을 개지 않음, (B) 요리를 하지 않음, (D) 다림질을 하지 않음",
  },
  {
    questionNumber: 11,
    choices: {
      A: "A woman is taking out an iron.",
      B: "A woman is ironing a piece of clothing.",
      C: "A woman is folding clothes.",
      D: "A woman is hanging up clothes.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 옷을 다림질하고 있음\n" +
      "오답 설명: (A) 다리미를 꺼내지 않음, (C) 옷을 개지 않음, (D) 옷을 걸지 않음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "A woman is ironing a shirt on a table.",
      B: "A woman is steaming a piece of clothing.",
      C: "A woman is folding laundry.",
      D: "A woman is spraying water on clothes.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 옷을 스팀 다리미로 다리고 있음\n" +
      "오답 설명: (A) 테이블에서 다리미질하지 않음, (C) 옷을 개지 않음, (D) 옷에 물을 뿌리지 않음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "A woman is putting clothes into a laundry basket.",
      B: "A woman is ironing a shirt.",
      C: "A woman is hanging clothes on a drying rack.",
      D: "A woman is folding clothes.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 여자가 옷을 개고 있음\n" +
      "오답 설명: (A) 바구니에 옷을 넣지 않음, (B) 다림질을 하지 않음, (C) 빨래를 널지 않음",
  },

  {
    questionNumber: 14,
    choices: {
      A: "A woman is hanging clothes on a drying rack.",
      B: "A woman is kneeling on the floor.",
      C: "A laundry basket is being carried across the room.",
      D: "A woman is placing clothes into a washing machine.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 무릎을 꿇고 앉아있음\n" +
      "오답 설명: (A) 빨래를 널지 않음, (C) 세탁 바구니를 운반하지 않음, (D) 세탁기에 옷을 넣지 않음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "A cup has been placed on the windowsill.",
      B: "A woman is wiping the kitchen counter.",
      C: "A dish is being washed.",
      D: "A towel is being hung on a rack.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 접시가 닦여지고 있음\n" +
      "오답 설명: (A) 창가에 컵이 없음, (B) 조리대를 닦지 않음, (D) 수건을 걸지 않음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "Some dishes have been left on the counter.",
      B: "A woman is loading a dishwasher.",
      C: "A man is wiping a cup.",
      D: "A sponge is being squeezed under the faucet.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 접시들이 조리대에 놓여있음\n" +
      "오답 설명: (B) 식기세척기에 넣지 않음, (C) 컵을 닦지 않음, (D) 스펀지를 짜지 않음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "The man is repairing a broken chair.",
      B: "A woman is sweeping the floor.",
      C: "The people are assembling furniture.",
      D: "A couple is hanging a painting on the wall.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 사람들이 가구를 조립하고 있음\n" +
      "오답 설명: (A) 의자를 수리하지 않음, (B) 바닥을 쓸지 않음, (D) 그림을 걸지 않음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "The woman is wiping the window with a cloth.",
      B: "A woman is trimming the leaves of a plant.",
      C: "The woman is pouring water into a glass.",
      D: "The potted plant is being watered.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 화분에 물이 주어지고 있음\n" +
      "오답 설명: (A) 창문을 닦지 않음, (B) 식물의 잎을 자르지 않음, (C) 물을 컵에 붓지 않음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "The woman is putting dishes into the dishwasher.",
      B: "The kitchen countertop is being wiped.",
      C: "Fruits are being placed in a bowl.",
      D: "A woman is putting on an apron.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 조리대가 닦여지고 있음\n" +
      "오답 설명: (A) 식기세척기에 그릇을 넣지 않음, (C) 과일이 이미 그릇에 담겨있음, (D) 이미 앞치마를 입고 있음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "The woman is dusting the shelves.",
      B: "A woman is organizing the books.",
      C: "The woman is reaching for an item on the shelf.",
      D: "A woman is carrying a box across the room.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 선반 위의 물건을 손을 뻗어 잡으려 하고 있음\n" +
      "오답 설명: (A) 선반을 닦지 않음, (B) 책을 정리하지 않음, (D) 상자를 운반하지 않음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "A woman is washing vegetables in the sink.",
      B: "A woman is placing food in the oven.",
      C: "Vegetables are being cut on a cutting board.",
      D: "A meal is being served at the table.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 도마 위에서 채소가 잘려지고 있음\n" +
      "오답 설명: (A) 채소를 씻지 않음, (B) 오븐에 음식을 넣지 않음, (D) 식탁에 음식을 서빙하지 않음",
  },

  {
    questionNumber: 22,
    choices: {
      A: "A woman is stirring a pot on the stove.",
      B: "A woman is setting the table for dinner.",
      C: "A woman is cutting vegetables.",
      D: "A woman is washing dishes in the sink.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여성이 스토브 위에서 냄비를 젓고 있음\n" +
      "오답 설명: (B) 식탁을 차리지 않음, (C) 채소를 자르지 않음, (D) 설거지를 하지 않음",
  },

  {
    questionNumber: 23,
    choices: {
      A: "A woman is putting bread into the oven.",
      B: "A woman is closing the oven door.",
      C: "A woman is taking bread out of the oven.",
      D: "A woman is pressing the oven buttons.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여성이 오븐에서 빵을 꺼내고 있음\n" +
      "오답 설명: (A) 빵을 넣지 않음, (B) 오븐 문을 닫지 않음, (D) 오븐 버튼을 누르지 않음",
  },
  {
    questionNumber: 24,
    choices: {
      A: "A child is picking flowers.",
      B: "A man is sitting on a bench.",
      C: "A man is grasping a watering can.",
      D: "A woman is planting trees.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 물뿌리개를 잡고 있음\n" +
      "오답 설명: (A) 아이가 꽃을 따지 않음, (B) 남자가 벤치에 앉아 있지 않음, (D) 여성이 나무를 심지 않음",
  },
  {
    questionNumber: 25,
    choices: {
      A: "A woman is watering the plants.",
      B: "A woman is crouching in the garden.",
      C: "A man is trimming the bushes.",
      D: "A woman is carrying a basket of vegetables.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 정원에서 쪼그려 앉아 있음\n" +
      "오답 설명: (A) 여성이 식물에 물을 주지 않음, (C) 남성이 덤불을 다듬지 않음, (D) 여성이 채소 바구니를 들고 있지 않음",
  },
  {
    questionNumber: 26,
    choices: {
      A: "A woman is painting a door frame.",
      B: "A cloth is hanging on the door.",
      C: "A door frame is being wiped.",
      D: "A woman is closing a window.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 문틀이 닦이고 있음\n" +
      "오답 설명: (A) 여성이 문틀을 페인트칠하지 않음, (B) 천이 문에 걸려 있지 않음, (D) 여성이 창문을 닫지 않음",
  },
  {
    questionNumber: 27,
    choices: {
      A: "A woman is opening the oven door.",
      B: "Some bread is being placed in the oven.",
      C: "A woman is adjusting the oven knob.",
      D: "A refrigerator is being cleaned.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여성이 오븐의 노브(조절 다이얼)를 돌리고 있음\n" +
      "오답 설명: (A) 여성이 오븐 문을 열고 있지 않음, (B) 빵이 오븐에 들어가는 장면이 아님, (D) 냉장고가 청소되는 장면이 아님",
  },
  {
    questionNumber: 28,
    choices: {
      A: "A cabinet is built into the wall.",
      B: "A man is washing vegetables in the sink.",
      C: "A chef is serving food to a customer.",
      D: "A dining table is set with dishes.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 수납장이 벽에 빌트인되어 있음\n" +
      "오답 설명: (B) 남자가 싱크대에서 채소를 씻고 있지 않음, (C) 요리사가 음식을 서빙하지 않음, (D) 테이블에 접시가 놓여 있지 않음",
  },
  {
    questionNumber: 29,
    choices: {
      A: "A couple is eating dinner at a table.",
      B: "A woman is using a laptop.",
      C: "A man is grasping a remote control.",
      D: "A television is turned off.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 리모컨을 손에 쥐고 있음\n" +
      "오답 설명: (A) 두 사람이 식사하는 장면이 아님, (B) 여성이 노트북을 사용하는 장면이 아님, (D) TV가 꺼져 있는지 확인할 수 없음",
  },
  {
    questionNumber: 30,
    choices: {
      A: "A woman is blending some fruit.",
      B: "A woman is peeling an orange.",
      C: "A microwave is being used.",
      D: "A cutting board is empty.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여성이 과일을 블렌더로 갈고 있음\n" +
      "오답 설명: (B) 여성이 오렌지를 껍질 벗기는 장면이 아님, (C) 전자레인지가 사용 중인지 알 수 없음, (D) 도마 위에 과일이 놓여 있음",
  },
  {
    questionNumber: 31,
    choices: {
      A: "A man is riding a bicycle on a road.",
      B: "A wooden shed is being built.",
      C: "A man is putting a bicycle into a shed.",
      D: "A door is being painted.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 자전거를 창고(쉐드)에 넣고 있음\n" +
      "오답 설명: (A) 남자가 도로에서 자전거를 타는 장면이 아님, (B) 창고가 지어지는 장면이 아님, (D) 문이 페인트칠되는 장면이 아님",
  },
];
